import { OutsideTag, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const ProportionChangeContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;
  justify-content: flex-end;
`;

export const OutsideHoursTag = styled.span<{ $tagType: OutsideTag }>`
  ${typographyV2.bodyXs}
  color: ${({ $tagType }) =>
    $tagType === 'pre' ? 'var(--text-primary)' : 'var(--text-soft)'};
  margin-right: 12px;
`;

export const LiveLabel = styled.span`
  color: var(--text-success);
  ${typographyV2.bodyXs}
`;

export const LiveLabelContainer = styled.div`
  width: 100%;
`;

export const DateSpan = styled.span`
  ${typographyV2.bodyXs}
  color: var(--text-soft);
`;
